module.exports = __webpack_public_path__ + "/images/ico-vendedores-estadisticas.e332bb4.svg";